const highPriority = ({ value = false } = {}) => {
  return {
    label: 'Critical',
    kind: 'high',
    key: 100,
    value,
  }
}
const mediumPriority = ({ value = false } = {}) => {
  return {
    label: 'Moderate',
    kind: 'medium',
    key: 50,
    value,
  }
}
const lowPriority = ({ value = false } = {}) => {
  return {
    label: 'Minor',
    kind: 'low',
    key: 0,
    value,
  }
}

const getManualFiltersFields = () => {
  return {
    priorityList: [highPriority(), mediumPriority(), lowPriority()],
    txAmountRange: {
      from: '',
      to: '',
    },
    triggeredAmountRange: {
      from: '',
      to: '',
    },
    scoreRange: {
      from: '',
      to: '',
    },
    listDates: [],
    depthRange: {
      from: '',
      to: '',
    },
    labels: [],
  }
}

const typeFilterItems = [
  {
    label: 'Single Address',
    value: 'single',
  },
  {
    label: 'Monitoring',
    value: 'monitoring',
  },
  {
    label: 'Risk Report',
    value: 'riskReport',
  },
  {
    label: 'Behavior',
    value: 'behavioral',
  },
]

const actionsListItems = [
  {
    title: 'Edit',
    value: 'edit',
    icon: 'edit-pencil-gray',
    disabled: false,
  },
  {
    title: 'Resolve',
    value: 'archive',
    icon: 'archive-3',
    disabled: false,
  },
  {
    title: 'Move To Active',
    value: 'to-active',
    icon: 'archive-3',
    disabled: false,
  },
  {
    title: 'Create Jira Ticket',
    value: 'create_jira_ticket',
    icon: 'jira-color',
    disabled: false,
  },
]

const activeListItems = ['edit', 'archive', 'create_jira_ticket']
const archiveListItems = ['edit', 'to-active', 'create_jira_ticket']

const loadingKeys = {
  csvDownload: 'csvDownload',
  kytUpload: 'kytUpload',
}
const MAX_JIRA_TICKETS_COUNT = 100

export {
  getManualFiltersFields,
  highPriority,
  mediumPriority,
  lowPriority,
  actionsListItems,
  activeListItems,
  archiveListItems,
  typeFilterItems,
  loadingKeys,
  MAX_JIRA_TICKETS_COUNT,
}
